import React from 'react';
import SignInForm from "./SignInForm/SignInForm";
import s from './SignIn.module.scss'
import {useAppSelector} from "../../app/hooks";
import { selectIsLoggedIn } from '../../store/userReducer';
import {Navigate} from "react-router-dom";

const SignIn = () => {
    const isLoggedIn = useAppSelector(selectIsLoggedIn)

    if (isLoggedIn) {
        return <Navigate to='/'/>

    }

    return (
        <div className={s.inner}>
            <h1 className={s.inner__title}>Log in to your account</h1>
            <p className={s.inner__text}>Welcome back! Please enter your details.</p>
            <SignInForm/>
        </div>
    );
};

export default SignIn;